import HeaderContainer from "./HeaderContainer";
import React from "react";
import { Container } from "react-bootstrap";
import FooterContainer from "./FooterContainer";
import OrderForm from "../components/OrderForm";

const OrderContainer = () => {
    return (
        <>
            <HeaderContainer title="Registro de Gastos"></HeaderContainer>
            <Container>
                <h1 style={{ margin: "15px" }}>Pedidos</h1>
                <OrderForm ></OrderForm>
            </Container>
            <FooterContainer />
        </>
    );
}

export default OrderContainer;